import React from 'react';

import Icon from 'components/atoms/Icon';
import Image from 'components/atoms/Image';
import Link from 'components/atoms/Link';
import Text from 'components/atoms/Text';
import mapModifiers from 'utils/functions';

export interface NewsCardProps {
  href: string;
  title: string;
  date?: string;
  imgSrc?: string;
  alt?: string;
  modifiers?: 'col-space-between';
  useExternal?: boolean;
  target?: string;
}

const NewsCard: React.FC<NewsCardProps> = ({
  href,
  title,
  date,
  imgSrc,
  alt,
  modifiers,
  useExternal,
  target,
}) => (
  <div className={mapModifiers('m-newsCard', imgSrc ? 'imgSrc' : 'normal', modifiers)}>
    {imgSrc && (
      <div className="m-newsCard_thumbnail">
        <Link href={href} useExternal={useExternal} target={target}>
          <Image
            imgSrc={imgSrc}
            alt={alt || 'thumbnail'}
            ratio="263x136"
            size="cover"
          />
        </Link>
      </div>
    )}
    <div className="m-newsCard_title">
      <Link href={href} useExternal={useExternal} target={target}>
        <Text modifiers={['700', 'raisinBlack', imgSrc ? 'md' : 'lg']}>{title}</Text>
      </Link>
    </div>
    {date && (
      <div className="m-newsCard_time">
        <Icon size="16" iconName="time" />
        <div className="m-newsCard_date">
          <Text modifiers={['500', 'davysGrey', 'sm']}>{date}</Text>
        </div>
      </div>
    )}
  </div>
);

export default NewsCard;
